import { render, staticRenderFns } from "./end-canvas.vue?vue&type=template&id=2db37311&scoped=true&"
import script from "./end-canvas.vue?vue&type=script&lang=js&"
export * from "./end-canvas.vue?vue&type=script&lang=js&"
import style0 from "./end-canvas.vue?vue&type=style&index=0&id=2db37311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db37311",
  null
  
)

export default component.exports